// Admin sipariş uçları: GET /admin/shop-orders, GET /admin/shop-orders/:id,
// PATCH /admin/shop-orders/:id/status
import { API_BASE } from "../config";

const handleResponse = async (response, fallbackMessage) => {
	let body = null;
	try {
		body = await response.json();
	} catch (_) {
		body = null;
	}
	if (!response.ok) {
		const error = new Error(body?.message || fallbackMessage);
		error.status = response.status;
		throw error;
	}
	return body;
};

// Tek yönlü iş akışı. Geçiş kuralları backend'de zorlanır; panel yalnızca
// backend'in döndürdüğü nextStatuses listesine göre buton gösterir.
export const ORDER_STATUSES = [
	{ key: "new", label: "Yeni Sipariş", variant: "new", action: "Hazırlamaya Başla" },
	{ key: "preparing", label: "Hazırlanıyor", variant: "preparing", action: "Hazırlandı, Kargoya Verilecek" },
	{ key: "ready_to_ship", label: "Kargoya Verilecek", variant: "ready", action: "Kargoya Verildi" },
	{ key: "shipped", label: "Kargoya Verildi", variant: "shipped", action: "Teslim Edildi" },
	{ key: "delivered", label: "Teslim Edildi", variant: "delivered", action: "Teslim Edildi Olarak İşaretle" },
	{ key: "paid", label: "Ödendi", variant: "paid", action: "Ödendi" },
	{ key: "cancelled", label: "İptal Edildi", variant: "cancelled", action: "Siparişi İptal Et" },
	{ key: "refunded", label: "İade Edildi", variant: "refunded", action: "İade Et" },
];

// Kargolu sipariş adımları (stepper için sıra)
export const SHIPPING_PIPELINE = ["new", "preparing", "ready_to_ship", "shipped", "delivered"];
export const TERMINAL_STATUSES = ["cancelled", "refunded"];

export const getStatusMeta = (key) =>
	ORDER_STATUSES.find((s) => s.key === key) || {
		key,
		label: key || "-",
		variant: "unknown",
		action: key,
	};

// Bir sonraki durum için buton metni: hedef duruma göre fiil.
export const getTransitionLabel = (toStatus) => {
	switch (toStatus) {
		case "preparing":
			return "Hazırlamaya Başla";
		case "ready_to_ship":
			return "Kargoya Hazır";
		case "shipped":
			return "Kargoya Verildi";
		case "delivered":
			return "Teslim Edildi";
		case "cancelled":
			return "Siparişi İptal Et";
		case "refunded":
			return "İade Et";
		default:
			return getStatusMeta(toStatus).label;
	}
};

export const getAdminOrders = async (params = {}) => {
	const qs = new URLSearchParams();
	Object.entries(params).forEach(([k, v]) => {
		if (v !== undefined && v !== null && v !== "") qs.set(k, v);
	});
	const response = await fetch(`${API_BASE}/admin/shop-orders?${qs.toString()}`);
	return handleResponse(response, "Siparişler alınamadı");
};

export const getAdminOrder = async (id) => {
	const response = await fetch(`${API_BASE}/admin/shop-orders/${id}`);
	return handleResponse(response, "Sipariş alınamadı");
};

export const SHIPPING_CARRIERS = [
	"Yurtiçi Kargo",
	"Aras Kargo",
	"MNG Kargo",
	"PTT Kargo",
	"Sürat Kargo",
	"UPS",
	"DHL",
	"Diğer",
];

// extra: { trackingNumber, carrier } — yalnızca "shipped" geçişinde gönderilir
export const updateOrderStatus = async (id, status, extra = {}) => {
	const response = await fetch(`${API_BASE}/admin/shop-orders/${id}/status`, {
		method: "PATCH",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ status, ...extra }),
	});
	return handleResponse(response, "Sipariş durumu güncellenemedi");
};

export const formatCurrency = (value, currency = "TRY") => {
	const num = Number(value);
	if (value === null || value === undefined || Number.isNaN(num)) return "-";
	try {
		return new Intl.NumberFormat("tr-TR", { style: "currency", currency }).format(num);
	} catch (_) {
		return `${num.toLocaleString("tr-TR")} ${currency}`;
	}
};

export const formatDateTime = (value) => {
	if (!value) return "-";
	const d = new Date(value);
	if (Number.isNaN(d.getTime())) return "-";
	return d.toLocaleString("tr-TR", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
	});
};
